import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Formik, Form } from 'formik';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useLocation,useNavigate } from 'react-router-dom';
import { Field, FieldArray } from 'formik';
import { doc, setDoc, } from 'firebase/firestore'; 
import {TemplatePreview} from './template-preview';
import { useFirestore } from 'reactfire';

import * as Yup from 'yup';
import moment from 'moment';
import { useAuthContext } from 'src/context/AuthContext';
import { v4 as uuid } from 'uuid';

import {IconButton,Button,Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
// Here is an example of a form with an editable list.
import AddIcon from '@material-ui/icons/Add';
import {TextField} from 'formik-material-ui';
// Next to each input are buttons for insert and remove.
// If the list is empty, there is a button to add an item.




const sleep = (ms:number) => new Promise((r) => setTimeout(r, ms));

export function CreateDialog() {
  const {pathname,search} = useLocation();
  const navigate = useNavigate();
  const open = search ==='?create';
  const theme = useTheme();
  const db = useFirestore();

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {user} = useAuthContext();
  console.log('user',user);
  const handleClose = ()=>{
    navigate(pathname);
  };
  return (
    <Formik
      initialValues={{ 
        date:moment().add(1,'day').format('DD-MM-YYYY'),
        attendanceItems: [{
          name:'',  
          time:''
        },{
          name:'',  
          time:''
        },{
          name:'',  
          time:''
        }] }}
      validationSchema={Yup.object().shape({
        attendanceItems: Yup
          .array()
          .of(
            Yup.object().shape({
              name:Yup.string().required('Required'),
              time: Yup.string().required('Required')
            })
          )
          .min(1)
      })}
      onSubmit={async (values) =>{
        const allData = {...values,group:user.group};
        const newUUID = uuid();
        await setDoc(doc(db, 'attendanceLists', newUUID), allData);
        navigate(`/app/attendance/${newUUID}`);
      }}
      render={({ values,errors }) => (
   
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="create-attendance-dialog"
        >
          <Form>
            <DialogTitle id="create-attendance-dialog">Create Attendance</DialogTitle>
            <DialogContent>
         
              <DialogContentText>
            Put in the attendance item below and click submit, then the system will generate a attendance for your group.
              </DialogContentText>

              {values.attendanceItems.length===0&& <Typography variant="h5" gutterBottom component="div">
               Please make sure all fields are filled properly
              </Typography>}
              <Field 
                name={'date'} 
                component={TextField} 
                label="Date"
                style={{flex:'auto', marginRight:8, marginBottom:8}}
                variant="outlined" 
                size="small" 
                disabled

                fullScreen
              />
              <FieldArray
                name="attendanceItems"
                render={arrayHelpers => (
                  <div>
                    {values.attendanceItems && values.attendanceItems.length > 0 ? (
                      values.attendanceItems.map((attendance, index) => (
                        <div key={index} style={{display:'flex'}}>
                          <Field 
                            name={`attendanceItems.${index}.name`} 
                            component={TextField} 
                            label="Gathering"
                            style={{flex:'auto', marginRight:8}}
                            variant="outlined" 
                            size="small" 
                            placeholder="e.g. Morning fishing🐟🐟🐟" 
                            fullScreen
                          />
                          <Field 
                            name={`attendanceItems.${index}.time`} 
                            component={TextField} 
                            style={{flex:'auto'}}
                            label="Time"
                            variant="outlined" 
                            size="small" 
                            placeholder="e.g.  9:15pm - 10pm" 
                            fullScreen
                          />

                          
                          
                          <IconButton aria-label="delete">
                            <DeleteIcon onClick={() => arrayHelpers.remove(index)}/>
                          </IconButton>
                        </div>
                      ))
                    ) : (
                      <Button size="small" variant='outlined' onClick={() => arrayHelpers.push({
                        attendance:'',  
                        time:''
                      })}>
                        {/* show this when user has removed all attendances from the list */}
                    Add a attendance
                      </Button>
                    )}
                    <IconButton aria-label="Insert">
                      <AddIcon onClick={() => arrayHelpers.insert(values.attendanceItems.length, '')}/>
                    </IconButton>
                  </div>
                )}
              />
              <TemplatePreview group={user.group} date={values.date} attendanceItems={values.attendanceItems}/>
              

            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
            Cancel
              </Button>
              <Button type="submit">
                Create
              </Button>
            </DialogActions>
          </Form>
        </Dialog>
       
      )}
    />
  );
}